import { Controller } from '@hotwired/stimulus';

// Contrôleur pour gérer l'affichage dynamique du champ de contact
// en fonction du type de client sélectionné (syndic de copropriété)
export default class extends Controller {
  static targets = ['contactField', 'contactSelect'];

  connect() {
    // Au chargement, on vérifie si un client est déjà sélectionné
    this.checkClientType();
  }

  // Appelé quand le client change dans le dropdown
  async checkClientType() {
    const clientSelect = this.element.querySelector("select[name='project[client_id]']");
    const clientId = clientSelect?.value;

    if (!clientId) {
      // Pas de client sélectionné, on masque le champ contact
      this.hideContactField();
      return;
    }

    try {
      // Récupérer les infos du client via l'API
      const response = await fetch(`/clients/${clientId}.json`);
      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();

      // Si le client est un syndic de copropriété, afficher le champ contact
      if (data.client_type === 'syndic_copropriete') {
        this.showContactField(data.contacts);
      } else {
        this.hideContactField();
      }
    } catch (error) {
      console.error('Error fetching client data:', error);
      this.hideContactField();
    }
  }

  showContactField(contacts) {
    // Vérifier que les targets existent
    if (!this.hasContactFieldTarget || !this.hasContactSelectTarget) {
      console.error('Targets contactField or contactSelect not found');
      return;
    }

    // Afficher le wrapper du champ
    this.contactFieldTarget.classList.remove('hidden');

    // Sauvegarder la valeur actuellement sélectionnée (si on édite)
    const select = this.contactSelectTarget;
    const currentValue = select.value;

    // Vider et remplir le select avec les contacts
    select.innerHTML = '<option value="">Sélectionner un gestionnaire</option>';

    contacts.forEach((contact) => {
      const option = document.createElement('option');
      option.value = contact.id;
      option.textContent = contact.name;
      // Restaurer la sélection si elle correspond
      if (contact.id.toString() === currentValue) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }

  hideContactField() {
    // Vérifier que les targets existent
    if (!this.hasContactFieldTarget || !this.hasContactSelectTarget) {
      return;
    }

    // Masquer le wrapper du champ et vider la sélection
    this.contactFieldTarget.classList.add('hidden');
    this.contactSelectTarget.value = '';
  }
}
